import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import p from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: e = 16, useVw: n, useRem: t, color: c, withColor: o, removeClassName: l, disableSSR: h, style: r, ...m }) => {
  const g = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ a.createElement(p, { disableSSR: h }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-renwuguangchang2", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (t ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (t ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: g, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: l ? "" : "32px-ä»»å¡å¹¿åº2"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: l ? "" : "normal",
        fill: o ? i(c, 0, "#262933") : "#262933",
        datafollowfill: o ? i(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M20.101 12.926a.9.9 0 0 1-.167 1.262l-5.005 3.837a.9.9 0 0 1-1.273-.181l-1.49-2.026a.9.9 0 0 1 1.45-1.066l.947 1.286 4.276-3.279a.9.9 0 0 1 1.262.167Zm-9.726 6.904a.9.9 0 0 0 0 1.8h8.549a.9.9 0 0 0 0-1.8h-8.549Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M22.864 4.996a.9.9 0 0 0-1.759-.381l-.311 1.439h-5.606l.247-1.027a.9.9 0 0 0-1.75-.42l-.349 1.447h-2.455a3.432 3.432 0 0 0-3.267 2.422v.001L2.878 23.686c-.684 2.202.953 4.463 3.267 4.463h19.732a3.392 3.392 0 0 0 3.385-3.64L28.148 9.184a.898.898 0 0 0-.033-.185 3.238 3.238 0 0 0-.24-.846 3.411 3.411 0 0 0-3.156-2.099h-2.084l.23-1.058Zm-2.46 2.858-.356 1.643a.9.9 0 0 0 1.759.381l.439-2.024h2.473a1.61 1.61 0 0 1 1.496.996l.005.01.004.01c.128.29.164.636.073 1.02l-3.79 15.218-.003.01a1.605 1.605 0 0 1-1.56 1.23H20.5l-.012.001H6.145c-1.084 0-1.877-1.07-1.548-2.13L9.333 9.01v-.002a1.632 1.632 0 0 1 1.548-1.154h2.022l-.388 1.612a.9.9 0 1 0 1.75.421l.49-2.033h5.649Zm3.544 18.495h1.93c.924 0 1.653-.78 1.588-1.714l-.675-9.282-2.537 10.185c-.069.289-.173.56-.306.81Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, v = x;
export {
  v as default
};
